import React, { useState, Fragment } from 'react';
import cx from 'classnames';
import SystemGuideCard from '../../../molecules/category/systemGuideCard/SystemGuideCard';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { Row } from '../../../atoms/row/Row';
import colors from '../../../../../tailwind.colors';
import { ArrowFull } from '../../../../../static/icons/arrowFull';
import { StyledHtmlDiv } from '../../../atoms/styledHtmlDiv/StyledHtmlDiv';
import CategorySubLinks from '../../../molecules/category/categorySubLinks/CategorySubLinks';
export const IntroGuideSection = ({ section, t }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="flex w-full flex-col flex-1 px-8 lg:mx-auto my-5 max-w-7xl">
      <div className="flex flex-col md:flex-row flex-1 justify-between py-4 gap-10 md:gap-2">
        <Stack
          className={cx('gap-4 md:mr-6 max-w-full md:max-w-lg', {
            'lg:max-w-2xl': !section.card,
          })}
        >
          <Stack
            className={`flex-1 relative ${
              expanded ? 'max-h-full' : 'max-h-52 overflow-hidden'
            }`}
          >
            {section.componentData?.map((item) => (
              <Fragment key={item.title}>
                <Typography
                  textAlign="left"
                  fontVariant="h8"
                  className="!text-secondary-400"
                >
                  {item.subtitle}
                </Typography>
                <Typography as="h2" textAlign="left" fontVariant="h4">
                  {item.title}
                </Typography>
                <StyledHtmlDiv
                  className="text-clamp-lg font-light normal-case text-left"
                  content={item.text}
                />
              </Fragment>
            ))}
            {section.linkTextToTextUnder && section.linkIdToTextUnder && (
              <a
                className="block global-hover mt-4 py-2 text-clamp-h8 font-medium !text-primary-700"
                href={`#${section.linkIdToTextUnder}`}
              >
                {section.linkTextToTextUnder}
              </a>
            )}
            {!expanded && (
              <div className="bg-gradient-to-t from-primary-50 to-transparent absolute bottom-0 top-0 right-0 left-0" />
            )}
          </Stack>
          {!expanded && (
            <Row className="flex items-center gap-2 global-hover w-fit">
              <button
                type="button"
                onClick={toggleExpand}
                className="flex-row flex items-center py-2 pr-2 gap-2 global-hover w-fit text-clamp-h8 font-medium normal-case text-left !text-primary-700"
              >
                {t('common.readMore')}
                <ArrowFull color={colors.primary[700]} direction="right" />
              </button>
            </Row>
          )}
        </Stack>
        {section.cardSubCategories?.links?.length > 0 && (
          <CategorySubLinks
            title={section.cardSubCategories.title}
            description={section.cardSubCategories.description}
            links={section.cardSubCategories.links}
            handleClick={section.cardSubCategories.handleClick}
          />
        )}
        {section.cardSystemGuide && (
          <SystemGuideCard
            title={section.cardSystemGuide.title}
            description={section.cardSystemGuide.description}
            href={section.cardSystemGuide.url}
            icon={section.cardSystemGuide.icon}
            handleClick={section.cardSystemGuide.handleClick}
            label={section.cardSystemGuide.label}
          />
        )}
      </div>
    </div>
  );
};
